<template>
  <div class="leads-page">
    <div class="leads-container">
      <div class="head">
        <div class="label">{{ $t(`${i18nPrefix}.label.myLeads`) }}</div>
      </div>
      <div class="container">
        <el-menu :default-active="activeIndex" router class="leads-menu" mode="horizontal">
          <el-menu-item
            v-for="(item, index) in tabList"
            class="menu-item"
            :key="index"
            :index="getUrlPath(item.path)"
          >
            {{ item.meta.title || $t(item.meta.menuI18nKey) }}
          </el-menu-item>
        </el-menu>
        <router-view class="content" ref="referral" @showLoading="showLoading"/>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { isEn } from '@/i18n'

export default {
  props: {
    personalInfo: {
      type: Object
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.leads',
      activeName: 'leads',
      loading: false,
      showTab: true,
      activeIndex: null
    }
  },
  computed: {
    tabList () {
      return _.filter(this.$route.meta._parent.children, item => {
        if (item.meta.onlyEmployee && !this.personalInfo.employee) {
          return false
        }
        return true
      })
    },
    isEn () {
      return isEn()
    }
  },
  created () {
    this.activeName = this.$route.name
  },
  mounted () {
    this.$el.parentElement.addEventListener('scroll', this.handleScroll)
  },
  unmounted () {
    this.$el.parentElement.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    showLoading (loading) {
      this.loading = loading
    },
    handleScroll (e) {
      const element = e.srcElement
      if (element.scrollTop + element.offsetHeight + 50 >= element.scrollHeight) {
        const ref = this.$refs.referral
        if (ref && ref.handleScroll) {
          ref.handleScroll()
        }
      }
    },
    getUrlPath (path) {
      const query = {}
      _.forEach(this.$route.query, (value, key) => {
        if (value !== null && value !== undefined) {
          query[key] = value
        }
      })
      const queryParams = new URLSearchParams(query).toString()
      if (queryParams) {
        path = `${path}?${queryParams}`
      }
      return path
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.activeIndex = this.getUrlPath(this.$route.path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.leads-page {
  min-height: calc(100vh - var(--header-height, 124px) - 28px);
  min-height: calc(100dvh - var(--header-height, 124px) - 28px);
  background-color: #fff;

  .leads-container {
    .head {
      display: flex;
      position: sticky;
      top: -14px;
      height: 52px;
      padding: 16px 0 16px 40px;
      z-index: 3;
      background-color: #fff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

      .label {
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #606266;
      }
    }

    .container {
      padding: 24px 40px;
      background-color: #fff;

      .leads-menu {
        .menu-item {
          font-size: 14px;
          line-height: 20px;
          padding: 10px 0;
          margin: 0 40px;
          height: 40px;

          &:first-child {
            margin-left: 0;
          }
        }

        .menu-item.is-active {
          color: #0096cc;
          border-bottom: 1px solid #0096cc;
        }
      }

      .content {
        margin: 24px 0;
      }
    }
  }
}
</style>
